export default function canRequestFreeTrial(user, teams) {
  if (!user || !user.verified || !Array.isArray(teams)) return false;
  const { can_request_free_trial: userCanRequestFreeTrial } = user.limitations;

  // Try to find a team that cannot request the free trial (Team Expert license)
  const teamCannotRequestFreeTrial = teams.find((tm) => !tm.limitations.can_request_free_trial);

  return userCanRequestFreeTrial && !teamCannotRequestFreeTrial;
}
